"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPageCancelDisabled = exports.ErrorPage = void 0;
const ErrorPage_1 = __importDefault(require("./ErrorPage"));
exports.ErrorPage = ErrorPage_1.default;
const ErrorPageCancelDisabled_1 = __importDefault(require("./ErrorPageCancelDisabled"));
exports.ErrorPageCancelDisabled = ErrorPageCancelDisabled_1.default;
//# sourceMappingURL=index.js.map